window.BAO.EventBus = class EventBus {
  constructor () {
    /**
     * @type {HTMLDivElement}
     * @private
     */
    this._bus = document.createElement('div')
  }

  /**
   * @param {keyof HTMLElementEventMap} event
   * @param {Function} callback
   *
   * @returns {undefined}
   */
  addEventListener (event, callback) {
    this._bus.addEventListener(event, callback)
  }

  /**
   * @param {keyof HTMLElementEventMap} event
   * @param {Function} callback
   *
   * @returns {undefined}
   */
  removeEventListener (event, callback) {
    this._bus.removeEventListener(event, callback)
  }

  /**
   * @param {keyof HTMLElementEventMap} event
   * @param {Object.<string, any>} detail
   *
   * @returns {undefined}
   */
  dispatchEvent (event, detail = {}) {
    this._bus.dispatchEvent(new CustomEvent(event, { detail }))
  }
}